import { render } from "./S3.vue?vue&type=template&id=60be2b93&scoped=true"
import script from "./S3.vue?vue&type=script&lang=js"
export * from "./S3.vue?vue&type=script&lang=js"

import "./S3.vue?vue&type=style&index=0&id=60be2b93&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60be2b93"]])

export default __exports__